<template>
    <section class="gmp-section gmp-mb-l">
        <div class="highlights-module">
            <div class="h-c-page">
                <div class="h-c-grid highlights-module__sticky-wrapper">
                    <div class="h-c-grid__col h-c-grid__col-l--6">
                        <div class="highlights-module__sticky-el">
                            <img src="@/assets/img/1_0.png" class="gmp-no-grab highlights-module__image-desktop"
                                 alt="">
                        </div>
                    </div>

                    <div class="h-c-grid__col h-c-grid__col-l--5 highlights-module__content">
                        <h3 class="h-c-headline h-c-headline--one h-has-bottom-margin">
                            保证产品质量的前提下
                        </h3>
                        <p></p>
                        <picture>
                            <img src="@/assets/img/1_0.png" alt=""
                                 class="gmp-no-grab highlights-module__image-mobile">
                        </picture>

                        <div class="highlights-module__listing">
                            <ul class="highlights-module__highlights">

                                <li class="highlights-module__highlight">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four h-has-bottom-margin">
                                        优化库存管理，减少浪费
                                    </h4>
                                    <p>"时鲜管理端"可以实时监控各个售卖窗口的库存情况，包括食材的保质期和销售情况。这有助于售卖窗口及时调整订单量，减少食品过期或滞销带来的浪费，确保每个售卖窗口始终有新鲜的产品可供销售</p>
                                </li>
                                <li class="highlights-module__highlight">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four h-has-bottom-margin">
                                        精准采购，降低成本
                                    </h4>
                                    <p>"集中采购端"可以统一从供应商那里采购原材料，由工厂集中加工，然后配送到各个售卖窗口。这种集中的采购方式可以利用规模效应，降低采购成本，同时避免各窗口分散采购带来的不一致性和价格波动。</p>
                                </li>
                                <li class="highlights-module__highlight">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four h-has-bottom-margin">
                                        高效的订单处理
                                    </h4>
                                    <p>"门店订货端"可以让售卖窗口的负责人根据销售情况和库存需求快速下单，从工厂获取需要的加工食品。系统提供的预估和推荐功能可以帮助门店更精准地订货，避免缺货或过量备货的情况。</p>
                                </li>
                                <li class="highlights-module__highlight">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four h-has-bottom-margin">
                                        精确的销售和成本分析
                                    </h4>
                                    <p>"门店管理端"提供了详细的销售数据和成本分析工具。售卖窗口可以通过数据分析，了解哪些产品销售最好，哪些产品利润更高，从而做出更好的产品组合和定价决策。这也有助于优化销售策略，提升整体盈利能力</p>
                                </li>

                            </ul>
                            <a @click="toEnterprisePage('/enterprise/windowStore/WIN_Benefit','/enterprise/windowStore/WIN_Benefit')" class="h-c-link gmp-link">
                                wins查看所有优点
                            </a>
                        </div>
                    </div>

                </div>


                <div class="highlights-module__carousel highlights-module__carousel--horizontal">

                    <div class="glue-pagination h-c-carousel h-c-carousel--simple ng-isolate-scope glue-o-pagination">

                        <div class="h-c-carousel__wrap ng-scope">
                            <ul class="glue-carousel glue-is-ready" id="highlightsUl"
                                style="width: auto; transform: none">
                                <li class="h-c-carousel__item">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four highlights-module__subhead">
                                        优化库存管理，减少浪费
                                    </h4>
                                    <div class="highlights-module__description">
                                        <p>"时鲜管理端"可以实时监控各个售卖窗口的库存情况，包括食材的保质期和销售情况。这有助于售卖窗口及时调整订单量，减少食品过期或滞销带来的浪费，确保每个售卖窗口始终有新鲜的产品可供销售</p>
                                    </div>

                                </li>
                                <li class="h-c-carousel__item">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four highlights-module__subhead">
                                        精准采购，降低成本
                                    </h4>
                                    <div class="highlights-module__description">
                                        <p>"集中采购端"可以统一从供应商那里采购原材料，由工厂集中加工，然后配送到各个售卖窗口。这种集中的采购方式可以利用规模效应，降低采购成本，同时避免各窗口分散采购带来的不一致性和价格波动。</p>
                                    </div>

                                </li>
                                <li class="h-c-carousel__item">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four highlights-module__subhead">
                                        高效的订单处理
                                    </h4>
                                    <div class="highlights-module__description">
                                        <p>"门店订货端"可以让售卖窗口的负责人根据销售情况和库存需求快速下单，从工厂获取需要的加工食品。系统提供的预估和推荐功能可以帮助门店更精准地订货，避免缺货或过量备货的情况。</p>
                                    </div>

                                </li>
                                <li class="h-c-carousel__item">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four highlights-module__subhead">
                                        精确的销售和成本分析
                                    </h4>
                                    <div class="highlights-module__description">
                                        <p>"门店管理端"提供了详细的销售数据和成本分析工具。售卖窗口可以通过数据分析，了解哪些产品销售最好，哪些产品利润更高，从而做出更好的产品组合和定价决策。这也有助于优化销售策略，提升整体盈利能力</p>
                                    </div>

                                </li>


                            </ul>
                        </div>

                        <div class="h-c-carousel__navigation product-card-grid__navigation ng-scope">
                            <ul class="glue-pagination-page-list ng-isolate-scope glue-o-pagination__page-list">
                                <li :class="{active:0 === activeIndex}"
                                    class=" glue-o-pagination__button-container  glue-o-pagination__page-list-button-container ng-scope "
                                    @click="showIndex(0)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"></button>
                                </li>
                                <li :class="{active:1 === activeIndex}"
                                    class="glue-o-pagination__button-container glue-o-pagination__page-list-button-container ng-scope"
                                    @click="showIndex(1)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"></button>
                                </li>
                                <li :class="{active:2 === activeIndex}"
                                    class="glue-o-pagination__button-container glue-o-pagination__page-list-button-container ng-scope"
                                    @click="showIndex(2)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"
                                    ></button>
                                </li>
                                <li :class="{active:3 === activeIndex}"
                                    class="glue-o-pagination__button-container glue-o-pagination__page-list-button-container ng-scope"
                                    @click="showIndex(3)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"
                                    ></button>
                                </li>


                                <div style="clear:both;"></div>

                            </ul>

                        </div>

                    </div>

                    <div class="highlights-module__cta highlights-module__cta--mobile">
                        <a @click="toEnterprisePage('/enterprise/windowStore/WIN_Benefit','/enterprise/windowStore/WIN_Benefit')" class="h-c-link gmp-link">
                            查看所有优点
                        </a>
                    </div>

                </div>

            </div>

        </div>

    </section>
</template>

<script>
    export default {
        name: "WIN_highLights",
        props: ['clientWidth'],
        data() {
            return {
                activeIndex: 0,
                itemWidth: ""
            }
        },

        watch: {
            clientWidth: function (val) {
                this.clientWidth = val
                this.changeFixed(this.clientWidth)
            },
        },


        methods: {
            showIndex(data) {
                // var itemWidth = this.$('.h-c-carousel__item').width();


                if(this.clientWidth < 600){
                    var itemWidth1 = this.$('.h-c-carousel').width();
                    var moveWidth1 = "";

                    moveWidth1 = - + data * itemWidth1;
                    console.log("1=====" + moveWidth1)
                    moveWidth1 = Number(moveWidth1) + Number(20)
                    console.log("2======" + moveWidth1);
                    this.$('#highlightsUl').css({
                        "transform": "translate3d(" + moveWidth1 + "px, 0px, 0px)",
                        "transition": "transform .4s"
                    })
                }else{
                    var itemWidth = this.$('.h-c-carousel').width();
                    var moveWidth = "";
                    moveWidth = - + data * itemWidth;
                    moveWidth = Number(moveWidth);
                    this.$('#highlightsUl').css({
                        "transform": "translate3d(" + moveWidth + "px, 0px, 0px)",
                        "transition": "transform .4s"
                    })
                }

                this.activeIndex = data;
            },


            changeFixed(data) {
                this.activeIndex = 0;
                var itemWidth = this.$('.h-c-carousel').width();
                var items = this.$('.h-c-carousel__item');
                var how = this.clientWidth * 5;
                for (var j = 0; j < items.length; j++) {
                    this.$(items[j]).css({
                        'width': itemWidth + 'px',
                        "min-width": "149px"
                    })
                }
                if (data < 1024) {
                    if (data < 600) {

                        if (this.activeIndex === 0) {
                            this.$('#highlightsUl').css({
                                'width': how + 'px',
                                "transform": "translate3d(20px, 0px,0px)",
                            })
                        } else {
                            var how1 = (Number(this.clientWidth) - Number(20)) * 5;
                            console.log("dayu600 < 1024")
                            this.$('#highlightsUl').css({
                                'width': how1 + 'px',
                                "transform": "translate3d(20px, 0px,0px)",
                            })
                        }

                    } else{
                        this.$('#highlightsUl').css({
                            'width': how + 'px',
                            "transform": "translate3d(0px, 0px,0px)",
                        })

                    }


                } else {
                    this.$('#highlightsUl').css({
                        'width': "auto",
                        "transform": "translate3d(0px, 0px,0px)",
                    })
                }
            },


            toEnterprisePage(data, url) {
                this.$router.push(data)
                this.$('body').removeClass('h-is-showing-drawer');
                var lis = this.$('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < lis.length; i++) {
                    var toWhere = this.$(lis[i]).attr('to-where');
                    console.log("toWhere===" + toWhere);
                    if (toWhere === url) {
                        this.$(lis[i]).addClass('h-is-active');
                    } else {
                        this.$(lis[i]).removeClass('h-is-active')
                    }
                }
            },
        }


    }
</script>

<style lang="less">



</style>